/* eslint-disable import/no-extraneous-dependencies */

import Admin from '../../components/Admin';

import getFilterWithCol from '../../helpers/getFilterWithCol';

const isNotCards = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'CARDS',
]);

const isNotContentCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_content',
  '!==',
  'custom',
]);

const isNotContentProducts = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_content',
  // eslint-disable-next-line no-unused-vars
  (value, props) => value && value !== 'products',
]);

const isNotModeManual = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_contentProducts.mode',
  (value) => value && value !== 'manual',
]);

const isNotModeDynamic = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'cards_contentProducts.mode',
  (value) => !value || value !== 'dynamic',
]);

export default [
  getFilterWithCol(['FieldRadio', {
    name: 'cards_layout',
    label: null,
    initialValue: 'carousel',
    choices: [
      { value: 'carousel', label: 'Carousel' },
      { value: 'grid', label: 'Grid' },
    ],
    block: true,
    isDisabled: () => true,
  }], 12),
  getFilterWithCol(['FieldRadio', {
    name: 'cards_style',
    label: null,
    choices: [
      { value: 'standard', label: 'Standard' },
      { value: 'minimal', label: 'Minimal' },
    ],
    initialValue: 'standard',
    block: true,
    isDisabled: () => true,
  }], 12),
  getFilterWithCol(['FieldRadio', {
    name: 'cards_content',
    label: null,
    choices: [
      { value: 'products', label: 'Products' },
      { value: 'custom', label: 'Custom Items' },
    ],
    initialValue: 'products',
    block: true,
    isDisabled: () => true,
  }], 24),
  getFilterWithCol(['FieldRadio', {
    name: 'cards_contentProducts.mode',
    label: null,
    choices: [
      { value: 'manual', label: 'Manual' },
      { value: 'dynamic', label: 'Dynamic' },
    ],
    initialValue: 'manual',
    skip: [isNotContentProducts],
    block: true,
  }], 24),
  getFilterWithCol(['FieldSortableList', {
    name: 'cards_contentProducts.items',
    label: null,
    addButtonLabel: 'Add Product',
    skip: [
      isNotContentProducts,
      isNotModeManual,
    ],
    head: 'horizontal',
    fields: [
      ['FieldConnectionSelect', {
        name: 'product',
        label: null,
        url: '/products',
        placeholder: 'Product',
        getExtraQueryConditions: (props) => [{
          store: props.forms[1]?.getFieldValue('store') || props?.viewer?.store,
        }],
        searchPaths: ['name'],
      }],
    ],
  }], 24),
  getFilterWithCol(['FieldRadio', {
    name: 'cards_contentProducts.featuredOnSale',
    label: null,
    initialValue: null,
    choices: [
      { value: null, label: 'All' },
      { value: 'ON_SALE', label: 'On Sale Only' },
      { value: 'FEATURED', label: 'Featured Only' },
      { value: 'FEATURED_ON_SALE', label: 'Featured And On Sale' },
    ],
    skip: [
      isNotContentProducts,
      isNotModeDynamic,
    ],
    block: true,
  }], 24),
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'cards_contentProducts.categories',
    label: null,
    prefix: 'Categories:',
    mode: 'multiple',
    url: '/categories',
    getExtraQueryConditions: (props) => [{
      store: props.forms[0]?.getFieldValue('store') || props?.viewer?.store,
    }],
    searchPaths: ['name'],
    skip: [
      isNotContentProducts,
      isNotModeDynamic,
    ],
  }], 24),
  getFilterWithCol(['FieldSelect', {
    name: 'cards_contentProducts.sortBy',
    label: null,
    prefix: 'Sort By:',
    initialValue: 'createdAt',
    choices: [
      { value: 'createdAt', label: 'Date Created' },
      { value: 'price', label: 'Price' },
    ],
    skip: [
      isNotContentProducts,
      isNotModeDynamic,
    ],
    block: true,
  }], 12),
  getFilterWithCol(['FieldSelect', {
    name: 'cards_contentProducts.sortDirection',
    label: null,
    prefix: 'Sort Direction:',
    initialValue: 'DESC',
    choices: [
      { value: 'ASC', label: 'Ascending' },
      { value: 'DESC', label: 'Descending' },
    ],
    skip: [
      isNotContentProducts,
      isNotModeDynamic,
    ],
    block: true,
  }], 12),
  getFilterWithCol(['FieldSortableList', {
    name: 'cards_contentCustom.items',
    label: null,
    addButtonLabel: 'Add Item',
    supportDuplicate: true,
    collapseFieldName: '__collapsed',
    collapseLabelFieldName: 'title',
    collapseLabelDefault: 'Item',
    skip: [isNotContentCustom],
    fields: [
      getFilterWithCol(['FieldUploadRefsHorizontal', {
        name: 'image',
        label: null,
        maxCount: 1,
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        transformations: [
          ['GM', { command: 'compress', maxWidth: 1200 }],
          ['GM', { command: 'webp' }],
        ],
        listType: 'picture',
        uploadLabel: 'Upload Image',
      }], 24),
      getFilterWithCol(['FieldText', {
        name: 'title',
        label: null,
        prefix: 'Title:',
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'subtitle',
        label: null,
        prefix: 'Subtitle:',
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'link',
        label: null,
        prefix: 'Link:',
      }], 12),
      getFilterWithCol(['FieldRadio', {
        name: 'featured',
        label: null,
        choices: [
          { value: false, label: 'Regular' },
          { value: true, label: 'Featured' },
        ],
        initialValue: false,
        block: true,
      }], 12),
    ],
  }], 24),
].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
  fieldType,
  { ...fieldConfig, skip: [isNotCards, ...(fieldConfig.skip || [])] },
]));
